import React from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'lodash';
import CenteredLoader from 'app/components/CenteredLoader';
import ServerResponseError from './ServerResponseError';
import ServerResponse from './ServerResponse';
import { useTrackPage } from 'api';

export default function ServerResponseOutput({ loading, data, trackingEventName }) {
  useTrackPage(trackingEventName);

  if (loading) {
    return <CenteredLoader />;
  }

  // TODO: Deal with this
  if (!data) {
    return null;
  }

  if (!isNil(data.error)) {
    return <ServerResponseError error={data.error} />;
  }

  return <ServerResponse integrationResponse={data.integrationResponse} />;
}

ServerResponseOutput.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.shape({
    error: PropTypes.string,
    integrationResponse: PropTypes.string,
  }),
  trackingEventName: PropTypes.string.isRequired,
};
